module.exports = __webpack_public_path__ + "static/media/cous.b9cb459b.jpg";